import { ReactNode } from "react";
import { Flex, Layout } from "antd";
import { Menu } from "../Menu";
import { Content } from "antd/es/layout/layout";
import styles from "./layout.module.css";
import { Header } from "components/Header";
import { Footer } from "components/Footer";

interface WrapProps {
  children?: ReactNode;
  showBack?: boolean;
  showHeader?: boolean;
}

export const EmptyLayout: React.FC<WrapProps> = ({ children, showHeader = false }) => {
  return (
    <Layout>
      <Flex vertical justify="space-between" className={styles.layoutHeight}>
        <Header />
        <Flex flex={1} align="center" justify="center">
          {children}
        </Flex>
        <Footer />
      </Flex>
    </Layout>
  );
};

export const BaseLayout: React.FC<WrapProps> = ({ children, showBack }) => {
  return (
    <Flex vertical>
      <Header showBack={showBack} />
      <Layout className={`${styles.container} ${styles.layoutHeight}`}>
        <Content className={styles.content}>{children}</Content>
      </Layout>
      <Footer />
    </Flex>
  );
};
